import resume from '../assets/pdf/r-resume.pdf'

export const headerData = {
    name: 'Ritik Masand',
    title: "Web Developer",
    desciption:"As a fresher, I want to contribute to the organization with my knowledge and skills. As well as want to enhance my personal skills in a stable and dynamic workplace. ",
    image: 'https://avatars.githubusercontent.com/u/77391068?v=4',
    resumePdf: resume
}
